export default function SectionMessage({ message }) {
  if (!message?.error && !message?.success) {
    return null;
  }

  return (
    <>
      {message.error && (
        <div className="alert alert-danger">{message.error}</div>
      )}

      {message.success && (
        <div className="alert alert-success">{message.success}</div>
      )}
    </>
  );
}